module.exports = __webpack_public_path__ + "img/pop-品牌旗舰店@2x(wap).ff26b3e9.jpg";